import { TrashIcon } from "@heroicons/react/24/solid";
import { teamMembersData } from "configs/teamMembers.config";
import { Col, Row } from "react-bootstrap";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Dropdown, IconButton, Input } from "stories";
import { teamMemberModel } from "./LoanDetailsMembers";
import MemberItem from "./MemberItem";

const CompanyItem = ({ index, onDelete }) => {
  const form = useFormContext();
  const {
    fields: members,
    append: addMember,
    remove: deleteMember,
  } = useFieldArray({
    control: form.control,
    name: `projectMembers[${index}].members`,
  });
  const handleAddMember = () => {
    addMember({ ...teamMemberModel });
  };

  return (
    <div className={"border-gray p-3 mb-3 relative"}>
      <Row>
        <Col>
          <div className="section-title fw-bold d-flex justify-content-between w-100">
            <span>Project Team Member {index + 1}</span>
            <span>
              <IconButton onClick={onDelete}>
                <TrashIcon className="icon-md text-red" />
              </IconButton>
            </span>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <Input
            label={"Company Name"}
            {...form.register(`projectMembers[${index}].company_name`)}
          />
        </Col>
        <Col xs={5}>
          <Dropdown
            label={"Project Role"}
            list={teamMembersData.projectRoleList}
            {...form.register(`projectMembers[${index}].project_role`)}
          />
        </Col>
      </Row>
      <Row>
        <Col xs={7}>
          <Input
            label={"Website"}
            {...form.register(`projectMembers[${index}].website`)}
          />
        </Col>
      </Row>
      <Row>
        <div className="section-title fw-bold mt-4">Company Team Members</div>
      </Row>
      <div className={"px-3"}>
        {members.map((item, i) => (
          <MemberItem
            key={item.id || item.key}
            memberIndex={index}
            index={i}
            onRemove={() => deleteMember(i)}
          />
        ))}
        <div
          className={"fw-bold text-primary my-3 d-inline-block"}
          role={"button"}
          onClick={handleAddMember}
        >
          + Add Company Team Members
        </div>
      </div>
    </div>
  );
};

export default CompanyItem;
